<template>
  <div class="relative lg:overflow-hidden lg:p-1">
    <ProductImageGalleryNew
      v-if="!isMobile"
      :product="product"
      :images="product.images"
      :product-name="productName"
      :product-order-number="productOrderNumber"
      :social-proof-badge="socialProofBadge"
      @click:image="toggleZoomGallery(true, $event)"
    />
    <ProductImageGallery
      v-if="isMobile"
      :product="product"
      :images="product.images"
      :product-name="productName"
      :product-order-number="productOrderNumber"
      :social-proof-badge="socialProofBadge"
      @click:image="toggleZoomGallery(true, $event)"
    />
    <LazyZoomGallery
      v-if="zoomGallery.display"
      :images="zoomGalleryImages"
      :product-name="productName"
      :active-index="zoomGallery.index"
      @click:close-zoom-gallery="toggleZoomGallery(false)"
    />
  </div>
</template>

<script setup lang="ts">
import type { Product } from '@scayle/storefront-nuxt'
import { computed, toRef } from 'vue'
import { useDeviceType } from '~/composables/useDeviceType'
import useZoomGalleryActions from '#layers/base/composables/ui/useZoomGalleryActions'
import usePdpSocialProofBadge from '~/composables/usePdpSocialProofBadge'
import { getMadPdpGalleryImages } from '~/utils/image'

const props = defineProps({
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  productName: {
    type: String,
    required: true,
  },
  productOrderNumber: {
    type: String as PropType<string>,
    default: '',
  },
})

defineEmits(['click:image', 'close:zoom-gallery'])

const { isMobile } = useDeviceType()

const { badge: socialProofBadge } = usePdpSocialProofBadge(
  toRef(props, 'product'),
)

// The zoom modal must render/paginate over the same catalog-first order the
// on-page gallery displays and emits indices against, else the active
// slide/dot is off by the catalog image's shift (ECOM-2643, comment 63550).
const zoomGalleryImages = computed(() =>
  getMadPdpGalleryImages(props.product.images, props.product, isMobile.value),
)

const { state: zoomGallery, toggle } = useZoomGalleryActions()

const toggleZoomGallery = (isOpen: boolean, index?: number) => {
  toggle(isOpen, index)
}
</script>
